import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/extraction-api/docs/')({
  head: () => buildHead('/products/extraction-api/docs'),
});

